import { render, staticRenderFns } from "./WorkAttentancePage.vue?vue&type=template&id=0fc34e6d&scoped=true&"
import script from "./WorkAttentancePage.vue?vue&type=script&lang=js&"
export * from "./WorkAttentancePage.vue?vue&type=script&lang=js&"
import style0 from "./WorkAttentancePage.vue?vue&type=style&index=0&id=0fc34e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc34e6d",
  null
  
)

export default component.exports